// extracted by mini-css-extract-plugin
module.exports = {"button_click":"ButtonClick_button_click__3tyQH","button_click_animate":"ButtonClick_button_click_animate__hcnkK"};